export default __webpack_public_path__ + "static/media/IIYAMA_21.9ad225aa.png";